export const environment = {
    version: '1.0.28',
    production: false,
    serviceWorkerEnabled: true,
    updateCheckInterval: 10 * 60 * 1000, // 10 minutes

    // API Configuration
    apiUrl: 'https://dev.api.americandronenetwork.com',
    webSocketUrl: 'wss://dev.api.americandronenetwork.com',

    appCDN: 'https://dev.cdn.americandronenetwork.com',
    // Brand assets (logos). Same host in every environment.
    staticCDN: 'https://static-cdn.americandronenetwork.com',

    // Compliance report recipients
    // Deliberately BLANK on staging — a staging test must never be able to one-click a real
    // report to the FAA. Blank renders an "address pending" notice and reveals the free-text
    // recipient input, so the flow stays fully testable with your own address.
    faaReportEmail: '',
    // ADN's DJI Regulatory Authority email, shown in the "connect a DJI drone" steps. Blank shows a
    // "contact support" notice instead; set the real address per environment once it is confirmed.
    djiRegulatoryAuthorityEmail: '',

    // Technical Support (Zoho Voice)
    technicalSupportPhone: '+18337371332',

    // Zoho Desk ASAP Widget
    zohoAsap: {
        enabled: true,
        scriptUrl: 'https://desk.zoho.com/portal/api/web/asapApp/1244338000000584054?orgId=910835565'
    },

    firebase: {
        apiKey: "AIzaSyBOfGg74w6N9HB3dSDlhOuJWT7nAOh1ZX0",
        authDomain: "american-drone-network-dev.firebaseapp.com",
        projectId: "american-drone-network-dev",
        storageBucket: "american-drone-network-dev.firebasestorage.app",
        messagingSenderId: "554938733533",
        appId: "1:554938733533:web:7f0e9206596f3758859c34",
        measurementId: "G-8TM77D5RBS",
        enableAnalytics: true
    }
};
